"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
class Card {
    static MappedAddresses;
    static ThemeArray;
    static Color;
}
exports.Card = Card;
(function (Card) {
    let TWCardColor;
    (function (TWCardColor) {
        TWCardColor["color1"] = "tw-bg-cardGradient1";
        TWCardColor["color2"] = "tw-bg-cardGradient2";
        TWCardColor["color3"] = "tw-bg-cardGradient3";
        TWCardColor["color4"] = "tw-bg-cardGradient4";
        TWCardColor["color5"] = "tw-bg-cardGradient5";
        TWCardColor["color6"] = "tw-bg-cardGradient6";
        TWCardColor["color7"] = "tw-bg-cardGradient7";
        TWCardColor["color8"] = "tw-bg-cardGradient8";
        TWCardColor["color9"] = "tw-bg-cardGradient9";
        TWCardColor["color10"] = "tw-bg-cardGradient10";
    })(TWCardColor = Card.TWCardColor || (Card.TWCardColor = {}));
    let cardColorTheme;
    (function (cardColorTheme) {
        cardColorTheme["dark"] = "Dark";
        cardColorTheme["light"] = "Light";
    })(cardColorTheme = Card.cardColorTheme || (Card.cardColorTheme = {}));
    Card.cardColorBg = {
        [cardColorTheme.light]: 'tw-bg-black',
        [cardColorTheme.dark]: 'tw-bg-white',
    };
    Card.cardColorStroke = {
        [cardColorTheme.light]: 'tw-stroke-black',
        [cardColorTheme.dark]: 'tw-stroke-white',
    };
    Card.cardColorText = {
        [cardColorTheme.light]: 'tw-text-black',
        [cardColorTheme.dark]: 'tw-text-white',
    };
    Card.cardColorFill = {
        [cardColorTheme.light]: 'tw-fill-black',
        [cardColorTheme.dark]: 'tw-fill-white',
    };
    let CardColor;
    (function (CardColor) {
        CardColor["color1"] = "color1";
        CardColor["color2"] = "color2";
        CardColor["color3"] = "color3";
        CardColor["color4"] = "color4";
        CardColor["color5"] = "color5";
        CardColor["color6"] = "color6";
        CardColor["color7"] = "color7";
        CardColor["color8"] = "color8";
        CardColor["color9"] = "color9";
        CardColor["color10"] = "color10";
    })(CardColor = Card.CardColor || (Card.CardColor = {}));
})(Card || (exports.Card = Card = {}));
//# sourceMappingURL=index.js.map